import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import logo from '@assets/654global.svg';
import noResult from '@assets/noResult.svg';
import { Button } from '@components/Button/Button';
import Image from '@components/Image/Image';
import { ERoutes } from '@enums/routes.enum';
import type { RootState } from '@store/store';

import classes from './ThankYouFeedback.module.scss';

const ThankYouFeedback: React.FC = () => {
	const id = useSelector((state: RootState) => state.trips.currentTrip?.id);
	const showGoBack = useSelector((state: RootState) => state.trips?.showGoBack);

	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleGoBack = () => {
		navigate(`${ERoutes.tripInfo}/${id}`);
	};

	return (
		<div className={classes['container']}>
			<img src={logo} alt="654 Global" className={classes['logo']} />
			<h1 className={classes['title']}>{t('thankYouFeedback.title')}</h1>
			<div className={classes['imageContainer']}>
				<Image src={noResult} name={t('search.imgAlt')} size="85dvw" />
			</div>
			{showGoBack && (
				<Button primary fullWidth onClick={handleGoBack}>
					{t('thankYouFeedback.button')}
				</Button>
			)}
		</div>
	);
};

export default ThankYouFeedback;
